import { OrderTotal, orderTotalFromResponse } from './OrderTotal';

export interface MyOrder {
  id: number;
  createdAt: Date;
  orderTotal: OrderTotal;
}

export const myOrderFromResponse = (responseData: any): MyOrder => ({
  id: responseData.id,
  createdAt: new Date(responseData.created_at),
  orderTotal: orderTotalFromResponse(responseData.total),
});
